import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const removeStaffInWarehouse = createAction(ACTION.REMOVE_STAFF_IN_WAREHOUSE.REQUEST, (params) => ({...params}));
